(ns common.schema.entities.exit-opportunity.schema
  (:require
   [common.schema.constraints :as constraints]
   [common.schema.entities.common :as common-schema]
   [common.schema.option-filters :as option-filters]
   [common.schema.schema-utils :as su]
   [common.status :as statuses]))

(def schema
  (vec
   (concat
    (su/text-simple-field
     :exit-opportunity/name
     "Name"
     {:name-attribute           :exit-opportunity/name
      :lower-case-str?          true
      :not-clearable?           true
      :mandatory-config         :mandatory/always
      :system-semantics         su/user-provided-system-required-field-semantics
      :system-required?         true
      :editor-type              :editor.type/none
      :default-field-visibility :in-use-disabled
      :constraints              {:constraint/string-min-length         1
                                 :constraint/unique-tenant-ignore-case
                                 {:validation-fn (partial constraints/tenant-unique-ignore-case
                                                          :exit-opportunity/name
                                                          [:entity.type/exit-opportunity])}}})
    #_(su/text-multiline-field :exit-opportunity/description
                               "Description"
                               {:create-visibility        :create.visibility/optional
                                :default-field-visibility :in-use})
    (su/single-ref-field :exit-opportunity/pipeline
                         "Pipeline"
                         [:entity.type/pipeline]
                         {:not-clearable?           true
                          :option-filter-fn         (partial option-filters/pipelines
                                                             :entity.type/exit-opportunity)
                          :mandatory-config         :mandatory/always
                          :system-semantics         su/user-provided-system-required-field-semantics
                          :system-required?         true
                          :field-in-use-filter      su/pipeline-in-use?
                          :default-field-visibility :in-use-disabled
                          :authorization            {:access/read :role/guest-buy-side}})
    (su/single-ref-field :exit-opportunity/buyer
                         "Buyer"
                         [:entity.type/investor]
                         {:create-on-fly?           true
                          :deep-indexing?           true
                          :select-entity-types      [:entity.type/person :entity.type/company]
                          :create-entity-types      [:entity.type/person :entity.type/company]
                          :editor-type              :editor.type/none
                          :grid-type                :editor.type/link
                          :filter                   :filter.type/select
                          :default-field-visibility :in-use-disabled})
    (su/single-ref-field :exit-opportunity/stage
                         "Stage"
                         [:entity.type/exit-opportunity-stage]
                         {:mandatory-config         :mandatory/always
                          :system-semantics         su/user-provided-system-required-field-semantics
                          :system-required?         true
                          :not-clearable?           true
                          :option-filter-fn         option-filters/exit-opportunity-stages-in-pipeline
                          :field-in-use-filter      su/pipeline-in-use?
                          :default-field-visibility :in-use-disabled})

    [[:exit-opportunity/status
      {:field/data-type :data.type/keyword
       :value-type :keyword
       :field/mandatory :mandatory/always
       :field/system-semantics su/user-provided-system-required-field-semantics
       :field/system-required? true
       :field/default-visibility {:editor :editor.type/none
                                  :grid   :editor.type/select
                                  :filter :filter.type/select
                                  :field-visibility :in-use-disabled}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/not-clearable? true
       :field/not-shown-in-create? true
       :field/translations {:en "Status"}
       :options statuses/exit-opportunity-status-options}]
     common-schema/team-members-field
     common-schema/common-network-drive-field]

    (su/datetime-field :exit-opportunity/put-on-hold-on
                       "Put on hold on"
                       {:editor-type       :editor.type/none
                        :grid-type         :editor.type/date
                        :filter-type       :filter.type/date
                        :default-field-visibility :in-use-disabled
                        :system-semantics  su/system-controlled-optional-field-semantics})
    (su/datetime-field :exit-opportunity/on-hold-until
                       "On hold until"
                       {:editor-type       :editor.type/none
                        :grid-type         :editor.type/date
                        :filter-type       :filter.type/date
                        :default-field-visibility :in-use-disabled
                        :system-semantics  su/system-controlled-optional-field-semantics})
    (su/text-multiline-field :exit-opportunity/on-hold-comment
                             "Last on hold comment"
                             {:create-visibility :create.visibility/optional
                              :default-field-visibility :in-use-disabled
                              :editor-type       :editor.type/none
                              :system-semantics  su/system-controlled-optional-field-semantics})

    (su/datetime-field :exit-opportunity/lost-on
                       "Lost on"
                       {:editor-type       :editor.type/none
                        :grid-type         :editor.type/date
                        :filter-type       :filter.type/date
                        :default-field-visibility :in-use-disabled
                        :system-semantics  su/system-controlled-optional-field-semantics})
    (su/datetime-field :exit-opportunity/won-on
                       "Won on"
                       {:editor-type       :editor.type/none
                        :grid-type         :editor.type/date
                        :filter-type       :filter.type/date
                        :default-field-visibility :in-use-disabled
                        :system-semantics  su/system-controlled-optional-field-semantics})

    (su/option-field :exit-opportunity/lost-reason
                     "Lost reason"
                     {:default-field-visibility :in-use-disabled
                      :create-visibility :create.visibility/optional
                      :editor-type :editor.type/none
                      :grid :editor.type/select
                      :system-semantics su/system-controlled-optional-field-semantics})
    (su/text-multiline-field :exit-opportunity/lost-comment
                             "Lost comment"
                             {:create-visibility :create.visibility/optional
                              :default-field-visibility :in-use-disabled
                              :editor-type       :editor.type/none})

    (su/single-ref-field :exit-opportunity/set-as-lost-by
                         "Set as lost by"
                         [:entity.type/account]
                         {:option-filter-fn         option-filters/active-users
                          :os-filter-terms-fn       (fn [{:keys [] :as _args}]
                                                      {"extras.active-user" true})
                          :default-field-visibility :in-use-disabled
                          :editor-type              :editor.type/none
                          :system-semantics         su/system-controlled-optional-field-semantics})
    (su/single-ref-field :exit-opportunity/set-as-won-by
                         "Set as won by"
                         [:entity.type/account]
                         {:option-filter-fn         option-filters/active-users
                          :os-filter-terms-fn       (fn [{:keys [] :as _args}]
                                                      {"extras.active-user" true})
                          :default-field-visibility :in-use-disabled
                          :editor-type              :editor.type/none
                          :system-semantics         su/system-controlled-optional-field-semantics})
    (su/single-ref-field :exit-opportunity/owner
                         "Owner"
                         [:entity.type/account]
                         ;;TODO should we limit this to accounts that have
                         ;; access to the exit-oppo's pipeline?
                         {:option-filter-fn         option-filters/active-users
                          :os-filter-terms-fn       (fn [{:keys [] :as _args}]
                                                      {"extras.active-user" true})
                          :system-semantics         su/system-prefilled-required-field-semantics
                          :system-required?         true
                          :not-clearable?           true
                          :default-field-visibility :in-use-disabled})
    ;;flagged-by - no need for separate attribute, handled via :account/flagged-entities
    (su/date-field :exit-opportunity/datetime-expected-closing-date
                   "Expected closing date"
                   {:default-field-visibility :in-use})
    (su/currency-field :exit-opportunity/cur-expected-EV
                       "Expected EV"
                       {:default-field-visibility :in-use})
    (su/percentage-field :exit-opportunity/probability-percentage
                         "Probability %"
                         {:default-field-visibility :in-use})
    ;;not-in-use:
    (su/multiplier-field :exit-opportunity/expected-EV-multiple
                         "Expected EV multiple"
                         {:default-field-visibility :not-in-use})
    (su/datetime-field :exit-opportunity/datetime-actual-closing-date
                       "Actual closing date"
                       {:editor-type       :editor.type/datetime
                        :grid-type         :editor.type/datetime
                        :filter-type       :filter.type/date
                        :default-field-visibility :not-in-use})
    (su/currency-field :exit-opportunity/cur-actual-EV
                       "Actual EV"
                       {:default-field-visibility :not-in-use})
    (su/multiplier-field :exit-opportunity/actual-EV-multiple
                         "Actual EV multiple"
                         {:default-field-visibility :not-in-use})
    (su/text-multiline-field :exit-opportunity/expected-r-and-w
                             "Expected R & W"
                             {:default-field-visibility :not-in-use})
    ;;in-use
    (su/option-field :exit-opportunity/expected-complexity
                     "Expected complexity"
                     {:default-field-visibility :in-use})
    (su/option-field :exit-opportunity/exit-type
                     "Exit type"
                     {:default-field-visibility :in-use})

    ;;not-in-use:
    (su/currency-field :exit-opportunity/cur-proposed-EV
                       "Proposed EV"
                       {:default-field-visibility :not-in-use})
    (su/multiplier-field :exit-opportunity/proposed-EV-multiple
                         "Proposed EV multiple"
                         {:default-field-visibility :not-in-use})
    (su/option-field-multi :exit-opportunity/proposed-payment-terms
                           "Proposed payment terms"
                           {:default-field-visibility :not-in-use})
    (su/option-field-multi :exit-opportunity/proposed-payment-method
                           "Proposed payment method"
                           {:default-field-visibility :not-in-use})

    (su/single-ref-field :exit-opportunity/target-holding
                         "Target holding"
                         [:entity.type/holding]
                         {:default-field-visibility :in-use-disabled
                          :editor-type    :editor.type/none
                          :grid-type      :editor.type/link
                          :filter         :filter.type/select
                          :hidden-from-configuration? true})

    (su/multi-ref-field :exit-opportunity/risk-entities
                        "Risks"
                        [:entity.type/risk-holding]
                        {:authorization    su/access-user-user
                         :editor-type      :editor.type/none
                         :grid-type        :editor.type/none
                         :filter-type      :filter.type/boolean
                         :required-modules [:module/risk-module]})

    common-schema/liabilities-schema

    ;; Boolean fields for checklists:
    (su/boolean-field :exit-opportunity/buyer-financing-secured
                      "Buyer financing is secured"
                      {:authorization            su/access-user-user
                       :default-field-visibility :in-use})
    (su/boolean-field :exit-opportunity/tax-implications-acceptable
                      "Tax implications are acceptable"
                      {:authorization            su/access-user-user
                       :default-field-visibility :in-use})
    (su/boolean-field :exit-opportunity/ready-for-dd
                      "Ready for DD"
                      {:authorization            su/access-user-user
                       :default-field-visibility :in-use})
    (su/boolean-field :exit-opportunity/management-alignment
                      "Management alignment"
                      {:authorization            su/access-user-user
                       :default-field-visibility :in-use})
    (su/boolean-field :exit-opportunity/regulator-perspective-ok
                      "Regulator perspective OK"
                      {:authorization            su/access-user-user
                       :default-field-visibility :in-use})
    (su/boolean-field :exit-opportunity/adequate-support-from-all-sellers
                      "Adequate support from all sellers"
                      {:authorization            su/access-user-user
                       :default-field-visibility :in-use})

;; Pre-exit checks:
    (su/single-ref-field :exit-opportunity/fund-manager-check
                         "Fund manager check"
                         [:entity.type/pre-exit-check]
                         {:editor-type              :editor.type/none
                          :grid-type                :editor.type/none
                          :filter-type              :filter.type/none
                          :authorization            su/access-user-user
                          :default-field-visibility :not-in-use})
    (su/single-ref-field :exit-opportunity/legal-and-compliance-check
                         "Legal check"
                         [:entity.type/pre-exit-check]
                         {:editor-type              :editor.type/none
                          :grid-type                :editor.type/none
                          :filter-type              :filter.type/none
                          :authorization            su/access-user-user
                          :default-field-visibility :not-in-use})

    (su/single-ref-field :exit-opportunity/asset-kyc-check
                         "KYC check"
                         [:entity.type/pre-exit-check]
                         {:editor-type              :editor.type/none
                          :grid-type                :editor.type/none
                          :filter-type              :filter.type/none
                          :authorization            su/access-user-user
                          :default-field-visibility :not-in-use})

    (su/single-ref-field :exit-opportunity/esg-sfdr-check
                         "ESG check"
                         [:entity.type/pre-exit-check]
                         {:editor-type              :editor.type/none
                          :grid-type                :editor.type/none
                          :filter-type              :filter.type/none
                          :authorization            su/access-user-user
                          :default-field-visibility :not-in-use})

    (su/single-ref-field :exit-opportunity/risk-check
                         "Risk check"
                         [:entity.type/pre-exit-check]
                         {:editor-type              :editor.type/none
                          :grid-type                :editor.type/none
                          :filter-type              :filter.type/none
                          :authorization            su/access-user-user
                          :default-field-visibility :not-in-use})
    (su/datetime-field :exit-opportunity/reactivated-on
                       "Reactivated on"
                       {:default-visibility :in-use-disabled
                        :editor-type        :editor.type/none
                        :system-semantics   su/system-controlled-optional-field-semantics
                        :authorization      su/access-system-user})
    (su/single-ref-field :exit-opportunity/reactivated-by
                         "Reactivated by"
                         [:entity.type/account]
                         {:default-visibility :in-use-disabled
                          :system-semantics   su/system-controlled-optional-field-semantics
                          :authorization      su/access-system-user}))))
